import actions from '@/vuex/modules/campaignDashboard/actions'
import getters from '@/vuex/modules/campaignDashboard/getters'
import mutations from '@/vuex/modules/campaignDashboard/mutations'

const state = {
  campaignList: {},
  report: [],
}

const campaignDashboard = {
  state,
  namespaced: true,
  getters,
  actions,
  mutations,
}

export default campaignDashboard
